import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero is-primary is-fullheight" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "columns is-centered" }
const _hoisted_5 = { class: "column is-5-tablet is-4-desktop is-4-widescreen" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "has-text-centered" }, " Reestablecer contraseña "),
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-justified" }, " El proceso de reestablecer contraseña esta en proceso, escribe tu nueva contraseña y confirmala. ")
], -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = ["disabled"]

import { authService } from "@/services/auth";
import route from "@/router";
import { ref, reactive, Ref, onMounted, readonly } from "vue";
import { useMessages } from "@/store/message";
import MessageNotificationList from "@/components/MessageNotificationList.vue";
import FailedValidation from "@/error/api/failed-validation";
import { useGrecaptchaV2, useGrecaptchaV3 } from "@/composables/use-grecaptcha";

/**
 *  Variables
 */

export default /*#__PURE__*/_defineComponent({
  props: {
  token: {
    type: String,
    required: true,
  },
  email: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const msg = useMessages();
const password = ref("");
const passwordConfirmation = ref("");
const isLoading = ref(false);
const isValidLink = ref(true);

const reCaptcha: Ref<HTMLElement> = ref(null as unknown as HTMLDivElement);
const v2SiteKey = ref("");
onMounted(async () => {
  v2SiteKey.value = await authService.getReCaptchaV2SiteKey();
});
const requestType = readonly(ref("signup"));
const recaptcha = reactive({
  reCaptchaV2SiteKey: null as null | string,
  reCaptcheType: "v3" as "v2" | "v3",
  reCaptchaV2Token: "",
});

const V2 = useGrecaptchaV2(reCaptcha, v2SiteKey);
const V3 = useGrecaptchaV3(requestType);

/**
 *  Incomming props
 */


/**
 *  Set message in case email undefined/null/empty
 */
if (props.email === null || props.email === undefined || props.email === "") {
  isValidLink.value = false;
  msg.addWarning(
    "El enlace no es valido, el email no esta presente. Verificá el enlace que se te envió previamente al correo."
  );
}

/**
 *  Methods
 */

const handleClick = async () => {
  if (password.value != passwordConfirmation.value) {
    msg.addError("Las contraseñas no coinciden.");
    return;
  }
  if (password.value.length < 8) {
    msg.addError(
      "La contraseña es muy corta. Debe tener al menos 8 caracteres."
    );
    return;
  }
  isLoading.value = true;
  try {
    let token_grecaptcha =
      recaptcha.reCaptcheType == "v3"
        ? await V3.validateV3recaptcha()
        : recaptcha.reCaptchaV2Token;

    await authService.resetPassword(
      password.value,
      passwordConfirmation.value,
      props.email as string,
      props.token as string,
      token_grecaptcha,
      recaptcha.reCaptcheType
    );
    msg.addSuccess("Tu contraseña ha sido reestablecida!");
    // redirect to login
    route.push({ name: "login" });
  } catch (e) {
    let message = "Intentelo de nuevo.";

    if (e?.response?.data?.type === "605") {
      message = "El link para reestablecer la contraseña ha expirado.";
    }

    if (e instanceof FailedValidation) {
      const failures = new Map(Object.entries(e.failures));
      if (failures.has("recaptcha") && recaptcha.reCaptcheType == "v3") {
        recaptcha.reCaptcheType = "v2";
        message = "Complete el captcha.";
        V2.renderV2Recaptcha().then(
          (token: string) => (recaptcha.reCaptchaV2Token = token)
        );
      }
    }
    msg.addError(`Ha ocurrido un error. ${message} `);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              class: "box",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
            }, [
              _hoisted_6,
              _createElementVNode("input", {
                class: "input block",
                type: "text",
                value: props.email,
                disabled: ""
              }, null, 8, _hoisted_7),
              _withDirectives(_createElementVNode("input", {
                class: "input is-info block",
                placeholder: "Nueva contraseña",
                type: "password",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
              }, null, 512), [
                [_vModelText, password.value]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "input is-info block",
                placeholder: "Confirmación de nueva contraseña",
                type: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordConfirmation).value = $event))
              }, null, 512), [
                [_vModelText, passwordConfirmation.value]
              ]),
              _createElementVNode("div", {
                ref_key: "reCaptcha",
                ref: reCaptcha,
                class: "field mt-3"
              }, null, 512),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: _normalizeClass(["button is-link is-fullwidth", { 'is-loading': isLoading.value }]),
                  onClick: handleClick,
                  disabled: !isValidLink.value
                }, " Reestablecer contraseña ", 10, _hoisted_9)
              ]),
              _createVNode(MessageNotificationList)
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}
}

})